import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "px-5 pb-4"
};
const _hoisted_2 = { class: "flex mb-3" };
const _hoisted_3 = { class: "flex flex-col items-center justify-center text-center py-20 gap-3" };
const _hoisted_4 = { class: "text-lg font-semibold text-gray-900" };
const _hoisted_5 = { class: "text-sm text-gray-500 max-w-md" };
const _hoisted_6 = {
    key: 2,
    class: "px-5 pb-4"
};
const _hoisted_7 = { class: "flex mb-3" };
const _hoisted_8 = { class: "flex flex-col items-center justify-center text-center py-20 gap-3" };
const _hoisted_9 = { class: "text-lg font-semibold text-gray-900" };
const _hoisted_10 = { class: "text-sm text-gray-500 max-w-md" };
const _hoisted_11 = {
    key: 3,
    class: "px-5 pb-4 flex flex-col flex-1 min-h-0"
};
const _hoisted_12 = { class: "contact-detail-tabs flex flex-wrap gap-4 py-4 shrink-0" };
const _hoisted_13 = { class: "self-center overflow-y-auto me-auto" };
const _hoisted_14 = ["id", "aria-labelledby"];
const _hoisted_15 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-5" };
const _hoisted_16 = { class: "flex flex-col gap-5 pb-5" };
const _hoisted_17 = { class: "grid grid-cols-2 gap-x-4 -mb-5" };
const _hoisted_18 = { class: "grid grid-cols-2 gap-x-4 -mb-5" };
const _hoisted_19 = { class: "grid grid-cols-2 gap-x-4 -mb-5" };
const _hoisted_20 = { class: "flex flex-col gap-5 pb-5" };
const _hoisted_21 = ["id", "aria-labelledby"];
const _hoisted_22 = ["id", "aria-labelledby"];
const _hoisted_23 = ["id", "aria-labelledby"];
const _hoisted_24 = ["id", "aria-labelledby"];
import { Button, ButtonGroup, buttonGroupTabId, ConfirmDeleteModal, DatePickerInput, Dropdown, FormSaveButton, InlineLink, MultipleSelect, NavHeader, SelectInput, TextInput, Tooltip, UnsavedChangesModal, WidgetShell, } from "@eudonet/opal";
import { useAppToast } from "@/shared/composables/useAppToast";
import { getCategoryBadgeTheme, CATEGORY_THEME_MAP } from "../../domain/contact-enums";
import { computed, ref, useId, watch } from "vue";
import { RouterLink, useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";
import { useI18n } from "vue-i18n";
import { buildRemoveChipLabel } from "@/shared/composables/removeChipLabel";
import { useContactDetail } from "../../composables/useContactDetail";
import { useContactRelations } from "../../composables/useContactRelations";
import { useContactIdentityForm } from "../../composables/useContactIdentityForm";
import { useContactProfileForm } from "../../composables/useContactProfileForm";
import { useContactIdentifiersForm } from "../../composables/useContactIdentifiersForm";
import { useProfileStore } from "@/modules/settings/stores/useProfileStore";
import { toDatePickerFormat, isoToDisplayDate, displayDateToIso } from "@/shared/utils/date-formatting";
import { useSaveOrchestrator } from "@/shared/composables/forms/useSaveOrchestrator";
import { useListNavPager, usePermissions } from "@/shared/composables";
import ContactDetailSkeleton from "../components/ContactDetailSkeleton.vue";
import ContactCoordonneesSection from "../components/ContactCoordonneesSection.vue";
import ContactSocialProfileSection from "../components/ContactSocialProfileSection.vue";
import { SocialProfileFormModal } from "@/shared/components/social-profiles";
import { contactSocialProfileApi } from "../../infrastructure/api/contactSocialProfileApi";
import { resolveApiErrorMessage } from "@/infrastructure/services/ApiErrorService";
import { useSocialNetworkStore } from "@/shared/stores/useSocialNetworkStore";
import ContactAddEmailModal from "../components/ContactAddEmailModal.vue";
import ContactEditEmailModal from "../components/ContactEditEmailModal.vue";
import DesignatePrimaryContactModal from "../components/DesignatePrimaryContactModal.vue";
import DesignateHouseholdPrincipalModal from "../components/DesignateHouseholdPrincipalModal.vue";
import ConfirmLastSharedOwnerModal from "../components/ConfirmLastSharedOwnerModal.vue";
import ContactAddressesWidget from "../components/ContactAddressesWidget.vue";
import ContactConsentsWidget from "../components/ContactConsentsWidget.vue";
import ContactAddressesExpandModal from "../components/ContactAddressesExpandModal.vue";
import ContactAddressFormModal from "../components/ContactAddressFormModal.vue";
import ContactDeleteAddressModal from "../components/ContactDeleteAddressModal.vue";
import { setContactPrimaryAddress } from "../../infrastructure/api/contactAddressApi";
import ContactAddPhoneModal from "../components/ContactAddPhoneModal.vue";
import ContactEditPhoneModal from "../components/ContactEditPhoneModal.vue";
import ContactRelationsTab from "../components/ContactRelationsTab.vue";
import ContactActiveRelationsWidget from "../components/ContactActiveRelationsWidget.vue";
import ContactDonationsTab from "../components/ContactDonationsTab.vue";
import ContactSubscriptionsTab from "../components/ContactSubscriptionsTab.vue";
import ContactConsentsTab from "../components/ContactConsentsTab.vue";
import { deleteContactEmail, deleteContactPhone, deleteContactAddress, deleteContactOrgAddressLink, getContactSharedEmailGroup, searchContacts } from "../../infrastructure/adapters/contactService";
import { updateContact, getContactDeletionPreview, deleteContact as deleteContactRequest } from "../../infrastructure/api/contactApi";
import { contactDisplayName } from "../../domain/contactDisplayName";
import DeleteContactModal from "../components/DeleteContactModal.vue";
import ContactDeletePermissionDeniedModal from "../components/ContactDeletePermissionDeniedModal.vue";
import { getApiErrorCode } from "@/infrastructure/services/ApiErrorService";
import { logger } from "@/infrastructure/services/LoggerService";
import ContactPropertiesModal from "../components/ContactPropertiesModal.vue";
import { PseudonymiseContactModal, useContactConformityState } from "@/modules/compliance/public";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactDetail',
    setup(__props) {
        const { t, locale } = useI18n();
        const removeChipLabel = buildRemoveChipLabel(t);
        const route = useRoute();
        const router = useRouter();
        const { canEditOphub: canEdit, canAdminOpink, disabledTooltip, isReady, can } = usePermissions();
        const profileStore = useProfileStore();
        const relationsTabRef = ref(null);
        const relationsInitialSubTab = ref("organisations");
        const showPropertiesModal = ref(false);
        const showPseudonymiseModal = ref(false);
        function navigateToRelations(section) {
            relationsInitialSubTab.value = section;
            handleTabChange("relations");
        }
        const id = computed(() => String(route.params.id));
        const { contact, loading, notFound, loadError, reload } = useContactDetail(id);
        const canPseudonymise = computed(() => can("opconf.edit"));
        const conformityState = useContactConformityState(id, canPseudonymise);
        watch(showPseudonymiseModal, (open) => {
            if (!open) {
                void conformityState.refresh();
            }
        });
        const { isPreviousDisabled, isNextDisabled, isFetchingPrevious, isFetchingNext, goToPrevious, goToNext, } = useListNavPager("contact", id, searchContacts);
        // Org IDs the contact already has a relation with — used to suppress the
        // "new relation will be created" hint in Add Email/Phone modals (OP-5851).
        // Loaded eagerly so the data is always ready before the modal opens, and
        // refreshed after each channel creation so subsequent opens see fresh state.
        const { relations: _contactOrgRelations, loading: _contactRelationsLoading, loadError: _contactRelationsLoadError, load: _loadContactRelations, reload: _reloadContactRelations, } = useContactRelations(id);
        void _loadContactRelations();
        const existingRelationOrgIds = computed(() => (_contactOrgRelations.value?.organisations ?? []).map(o => o.id));
        const contactProperties = computed(() => ({
            status: contact.value?.status ?? null,
            archivingReason: null,
            createdAt: contact.value?.createdAt ? contact.value.createdAt.toISOString() : null,
            updatedAt: contact.value?.updatedAt ? contact.value.updatedAt.toISOString() : null,
            createdBy: contact.value?.createdBy ?? null,
            updatedBy: contact.value?.updatedBy ?? null,
        }));
        const actionsMenuItems = computed(() => [
            {
                label: t("contact.detail.actions.properties"),
                icon: "ri-information-line",
                onClick: () => (showPropertiesModal.value = true),
            },
            ...(canPseudonymise.value
                ? [
                    {
                        label: t("contact.detail.actions.pseudonymise"),
                        icon: "ri-shield-user-line",
                        testId: "contact-action-pseudonymise",
                        disabled: conformityState.alreadyTreated.value,
                        tooltip: conformityState.alreadyTreated.value
                            ? t("contact.detail.actions.pseudonymiseAlreadyTreated")
                            : undefined,
                        onClick: () => (showPseudonymiseModal.value = true),
                    },
                ]
                : []),
            {
                label: t("contact.detail.actions.delete"),
                icon: "ri-delete-bin-line",
                danger: true,
                // isReady resolves asynchronously (see openDeleteContactFlow) — surface that "not known yet"
                // window as a visible loading state rather than a click that silently does nothing.
                disabled: !isReady.value,
                loading: !isReady.value,
                onClick: openDeleteContactFlow,
            },
        ]);
        const socialProfiles = ref([]);
        // ── Social profile modal (OP-5665) ────────────────────────────────────────────
        const showSocialModal = ref(false);
        const editingSocialProfile = ref(null);
        const socialModalError = ref(null);
        const socialModalLoading = ref(false);
        const SOCIAL_ERROR_KEYS = {
            "SocialProfile.SocialNetworkId.Duplicate": "contact.detail.socialNetworks.errors.duplicate",
        };
        const coordonneesAddItems = computed(() => [
            {
                label: t("contact.detail.contactInformation.addPhone"),
                icon: "ri-phone-line",
                onClick: () => { showAddPhoneModal.value = true; },
            },
            {
                label: t("contact.detail.contactInformation.addEmail"),
                icon: "ri-mail-line",
                onClick: () => { showAddEmailModal.value = true; },
            },
            {
                label: t("contact.detail.contactInformation.addSocialNetwork"),
                icon: "ri-share-line",
                onClick: openAddSocialProfile,
            },
        ]);
        function openAddSocialProfile() {
            editingSocialProfile.value = null;
            socialModalError.value = null;
            showSocialModal.value = true;
        }
        function openEditSocialProfile(profile) {
            editingSocialProfile.value = profile;
            socialModalError.value = null;
            showSocialModal.value = true;
        }
        async function onSocialProfileSave(saved) {
            socialModalLoading.value = true;
            socialModalError.value = null;
            try {
                if (saved.id) {
                    await contactSocialProfileApi.update(id.value, saved.id, {
                        networkId: saved.networkId,
                        value: saved.value,
                        label: saved.label,
                    });
                    const idx = socialProfiles.value.findIndex((p) => p.id === saved.id);
                    if (idx >= 0) {
                        socialProfiles.value[idx] = {
                            ...socialProfiles.value[idx],
                            value: saved.value,
                            label: saved.label,
                        };
                    }
                }
                else {
                    const newId = await contactSocialProfileApi.create(id.value, {
                        networkId: saved.networkId,
                        value: saved.value,
                        label: saved.label,
                    });
                    const network = useSocialNetworkStore().byId(saved.networkId);
                    // API orders by CreatedAt descending — newest at the top.
                    socialProfiles.value.unshift({
                        id: newId,
                        networkId: saved.networkId,
                        networkCode: saved.networkCode,
                        networkName: network?.name ?? saved.networkCode,
                        iconClass: saved.iconClass,
                        urlPrefix: saved.urlPrefix,
                        value: saved.value,
                        label: saved.label,
                    });
                }
                showSocialModal.value = false;
                toastSuccess("contact.detail.socialNetworks.saveSuccess");
            }
            catch (e) {
                socialModalError.value = resolveApiErrorMessage(e, SOCIAL_ERROR_KEYS, "contact.detail.socialNetworks.saveError");
            }
            finally {
                socialModalLoading.value = false;
            }
        }
        async function onSocialProfileDelete(profile) {
            socialModalLoading.value = true;
            socialModalError.value = null;
            try {
                await contactSocialProfileApi.delete(id.value, profile.id);
                socialProfiles.value = socialProfiles.value.filter((p) => p.id !== profile.id);
                showSocialModal.value = false;
                toastSuccess("contact.detail.socialNetworks.deleteSuccess");
            }
            catch (e) {
                socialModalError.value = resolveApiErrorMessage(e, SOCIAL_ERROR_KEYS, "contact.detail.socialNetworks.deleteError");
            }
            finally {
                socialModalLoading.value = false;
            }
        }
        // Identité bloc (OP-5558) — dedicated form state, field-level validation with
        // stable error codes, and its own read-merge-write `save()`. Registered as a
        // standalone bloc in the orchestrator below so it persists independently of the
        // other (not-yet-wired) sections.
        const { form: identity, isDirty: identityDirty, isValid: identityValid, errors: identityErrors, touch: touchIdentity, validate: validateIdentity, buildPayload: buildIdentityPayload, markAsSaved: markIdentitySaved, resetToOriginal: resetIdentity, } = useContactIdentityForm(contact);
        // Profil bloc (OP-5862) — qualification fields (categories, source, motivation,
        // relation level, frequency, preferred channel). Saved together with Identity in
        // a single merged PUT (see the `details` orchestrator bloc below).
        const { form: profile, isDirty: profileDirty, buildPayload: buildProfilePayload, markAsSaved: markProfileSaved, resetToOriginal: resetProfile, } = useContactProfileForm(contact);
        // Bridge: the identity form stores ISO yyyy-MM-dd; the picker displays the user's
        // profile format (R30).
        const dateFormat = computed(() => toDatePickerFormat(profileStore.profile?.dateFormat, locale.value));
        const identityBirthDateDisplay = computed({
            get: () => identity.birthDate
                ? isoToDisplayDate(identity.birthDate, profileStore.profile?.dateFormat, locale.value)
                : "",
            set: (display) => {
                identity.birthDate = display
                    ? displayDateToIso(display, profileStore.profile?.dateFormat, locale.value)
                    : "";
                touchIdentity("birthDate");
            },
        });
        // Age computed from the ISO birth date — display only, never persisted.
        const ageLabel = computed(() => {
            if (!identity.birthDate)
                return "—";
            const [year, month, day] = identity.birthDate.split("-").map(Number);
            const birth = new Date(year, month - 1, day);
            const now = new Date();
            let age = now.getFullYear() - birth.getFullYear();
            const m = now.getMonth() - birth.getMonth();
            if (m < 0 || (m === 0 && now.getDate() < birth.getDate()))
                age--;
            return t("contact.detail.identity.ageValue", { age });
        });
        // Identifiants bloc (OP-5564) — dedicated form state, per-type validation with
        // stable error codes, and its own save() that fans out create / update / delete
        // to the BFF identifier endpoints. Registered as a standalone bloc below.
        const { form: identifiers, isDirty: identifiersDirty, isValid: identifiersValid, errors: identifiersErrors, save: saveIdentifiers, resetToOriginal: resetIdentifiers, } = useContactIdentifiersForm(contact, id);
        const showUnsavedChangesModal = ref(false);
        const pendingTabKey = ref(null);
        // Page-level orchestrator (OP-5555). Aggregates dirty state across blocs,
        // owns the Vue Router beforeRouteLeave guard + beforeunload listener, and
        // fans out save() in parallel via Promise.allSettled.
        //
        // Today the page registers a single bloc (the monolithic `form`); future
        // bloc US (Identity / Coordonnées / Identifiers / …) will split the form
        // into widgets, each with its own dirty tracker and persistence handler.
        const { isDirty, isSaving, register, saveAll, proceedNavigation, cancelNavigation, } = useSaveOrchestrator({
            successToastKey: "contact.detail.saveSuccess",
            blocErrorToastKey: (blocId) => `contact.detail.${blocId}.saveError`,
            onNavigationBlocked: (_proceed, _cancel) => {
                // The orchestrator parks the navigation; we just surface the modal. The
                // stay/leave buttons call back into the orchestrator via the bound
                // handlers below.
                showUnsavedChangesModal.value = true;
            },
        });
        // Identity + Profile save as ONE bloc (OP-5862): a single merged PUT avoids two
        // concurrent updates racing on the same contact row (xmin conflict). Dirty and
        // inline errors stay per-bloc; the persistence is atomic. On a validation
        // failure or API error this `save()` throws, so the orchestrator emits the
        // `contact.detail.details.saveError` toast and the bloc stays dirty. Persist,
        // then silently refetch the aggregate so the header (title + avatar initials,
        // derived from `contact.value` via `fullName`) reflects the new name —
        // `reload({ silent: true })` keeps `loading` false (no skeleton) and swallows
        // its own failures (toast + `loadError`), so a refetch error never turns a
        // successful save into a per-bloc error.
        const detailsDirty = computed(() => identityDirty.value || profileDirty.value);
        register({
            id: "details",
            isDirty: detailsDirty,
            save: async () => {
                if (!validateIdentity()) {
                    throw new Error("Contact details validation failed");
                }
                await updateContact(id.value, {
                    ...buildIdentityPayload(),
                    ...buildProfilePayload(),
                });
                markIdentitySaved();
                markProfileSaved();
                await reload({ silent: true });
            },
        });
        // Identifiants bloc (OP-5564) — its own dirty flag + per-field save fan-out. On
        // a validation failure or API error `saveIdentifiers()` throws, so the
        // orchestrator emits the `contact.detail.identifiers.saveError` toast and the
        // bloc stays dirty.
        register({
            id: "identifiers",
            isDirty: identifiersDirty,
            save: saveIdentifiers,
        });
        watch(contact, (loaded) => {
            if (!loaded)
                return;
            socialProfiles.value = loaded.socialProfiles;
        }, { immediate: true });
        const fullName = computed(() => contact.value ? `${contact.value.firstName} ${contact.value.lastName}`.trim() : "");
        const STATUS_THEMES = {
            active: "green",
            suspended: "yellow",
            deceased: "red",
            inactive: "neutral",
            deleted: "neutral",
        };
        const statusTheme = computed(() => STATUS_THEMES[contact.value?.status.toLowerCase() ?? ""] ?? "neutral");
        const statusLabel = computed(() => {
            const status = contact.value?.status;
            if (!status)
                return "";
            const key = `contact.detail.status.${status.toLowerCase()}`;
            const translated = t(key);
            // vue-i18n echoes the key back when it is missing — fall back to the raw value.
            return translated === key ? status : translated;
        });
        function goToList() {
            router.push({ name: "Contact" });
        }
        function navigateToContact(siblingId) {
            return router.push({ name: "ContactDetail", params: { id: siblingId } });
        }
        // Score is not exposed by OPHUB / BFF yet (would require a new Domain field +
        // migration on the ophub side). The badge stays guarded so the day the BFF
        // returns it, only this computed needs to be lit up.
        const scoreLabel = computed(() => null);
        // Categories come from the profile form state so that header badges update
        // immediately when the user edits the field, before saving (OP-6070). The form
        // re-baselines from the BFF aggregate on load / contact switch / post-save
        // reload, so the header stays in sync with the persisted value at all times.
        // Each label is translated via `contact.detail.header.category.<member>` when a
        // matching key exists; falls back to the raw enum value.
        const categoryBadges = computed(() => profile.categories.map((raw) => {
            const i18nKey = `contact.detail.header.category.${raw.toLowerCase()}`;
            const translated = t(i18nKey);
            return {
                label: translated === i18nKey ? raw : translated,
                theme: getCategoryBadgeTheme(raw),
            };
        }));
        // NavHeader's record type shows the first 3 badges (status, score when present, categories) and
        // folds the rest into "+N".
        const headerBadges = computed(() => [
            { label: statusLabel.value, theme: statusTheme.value },
            ...(scoreLabel.value ? [{ label: scoreLabel.value, theme: "purple" }] : []),
            ...categoryBadges.value,
        ]);
        const pagerActions = computed(() => [
            {
                icon: "ri-arrow-left-line",
                label: t("contact.detail.header.previousContact"),
                ariaDisabled: isPreviousDisabled.value || isFetchingPrevious.value,
            },
            {
                icon: "ri-arrow-right-line",
                label: t("contact.detail.header.nextContact"),
                ariaDisabled: isNextDisabled.value || isFetchingNext.value,
            },
        ]);
        // Index 0 = previous, 1 = next (order of `pagerActions`).
        function handlePagerAction(_action, index) {
            if (index === 0)
                goToPrevious(navigateToContact);
            else
                goToNext(navigateToContact);
        }
        // ── Tabs ─────────────────────────────────────────────────────────────────────
        // 4 live contact fiche tabs (OP-5554 + OP-5696 + OP-5839 + OP-5996). All are
        // interactive; the not-yet-built tabs were hidden in OP-5996.
        const TAB_KEYS = ["details", "donations", "subscriptions", "relations", "consents"];
        const tabs = computed(() => TAB_KEYS.map((key) => ({ key, label: t(`contact.detail.tabs.${key}`) })));
        const activeTab = ref("details");
        const panelId = useId();
        const handleTabChange = (tabKey) => {
            if (tabKey === activeTab.value)
                return;
            if (isDirty.value) {
                pendingTabKey.value = tabKey;
                showUnsavedChangesModal.value = true;
            }
            else {
                if (activeTab.value === "relations") {
                    relationsInitialSubTab.value = "organisations";
                }
                activeTab.value = tabKey;
            }
        };
        // onBeforeRouteLeave (registered by useSaveOrchestrator) does NOT fire for
        // same-route param changes — only onBeforeRouteUpdate does. Guard pager
        // navigation here so clicking next/previous while editing still triggers the
        // UnsavedChangesModal.
        // We return a Promise so Vue Router waits for the user's decision; resolving
        // with `false` cancels the navigation, resolving with `undefined` lets it proceed.
        let pendingPagerNav = null;
        onBeforeRouteUpdate((to, from) => {
            if (to.params.id !== from.params.id && isDirty.value) {
                return new Promise((resolve) => {
                    showUnsavedChangesModal.value = true;
                    pendingPagerNav = { proceed: () => resolve(), cancel: () => resolve(false) };
                });
            }
        });
        // Modal "Stay" — cancels the route navigation if the orchestrator parked one;
        // no-op for an intra-page tab switch (orchestrator guards against null).
        const handleStay = () => {
            showUnsavedChangesModal.value = false;
            pendingTabKey.value = null;
            if (pendingPagerNav) {
                pendingPagerNav.cancel();
                pendingPagerNav = null;
            }
            else {
                cancelNavigation();
            }
        };
        // Resume whatever the guard interrupted — a queued tab switch, a pager move, or
        // a real route navigation. Shared by the discard path (after reverting) and the
        // save-and-continue path (after every bloc persisted).
        function proceedPendingNavigation() {
            if (pendingTabKey.value) {
                activeTab.value = pendingTabKey.value;
                pendingTabKey.value = null;
            }
            if (pendingPagerNav) {
                pendingPagerNav.proceed();
                pendingPagerNav = null;
            }
            else {
                proceedNavigation();
            }
        }
        // Modal "Leave" — discards the form changes, resumes the parked route
        // navigation (if any), and applies the queued tab switch.
        const handleLeave = () => {
            showUnsavedChangesModal.value = false;
            resetIdentity();
            resetProfile();
            resetIdentifiers();
            proceedPendingNavigation();
        };
        // Modal primary "Enregistrer les modifications" — persist every dirty bloc, then
        // resume the interrupted navigation only if all saved. A failing bloc stays
        // dirty (saveAll keeps it so and toasts), so the modal stays open for a retry.
        async function handleSaveAndContinue() {
            await saveAll();
            if (isDirty.value)
                return;
            showUnsavedChangesModal.value = false;
            proceedPendingNavigation();
        }
        // ── Identity select options ──────────────────────────────────────────────────
        // `value` is the canonical code persisted by OPHUB (Salutation/Gender enum
        // member name, ISO 3166-1 alpha-2 country code, BCP 47 locale tag) — must
        // match the values returned by GET /contacts/{id}, otherwise SelectInput finds
        // no matching option and renders empty.
        const civilityOptions = computed(() => [
            { value: "Mr", label: t("contact.detail.options.civility.mr") },
            { value: "Mrs", label: t("contact.detail.options.civility.mrs") },
            { value: "Ms", label: t("contact.detail.options.civility.ms") },
            { value: "Dr", label: t("contact.detail.options.civility.dr") },
            { value: "Other", label: t("contact.detail.options.civility.other") },
        ]);
        const genderOptions = computed(() => [
            { value: "Male", label: t("contact.detail.options.gender.male") },
            { value: "Female", label: t("contact.detail.options.gender.female") },
            { value: "NonBinary", label: t("contact.detail.options.gender.nonBinary") },
            { value: "Other", label: t("contact.detail.options.gender.other") },
            { value: "PreferNotToSay", label: t("contact.detail.options.gender.preferNotToSay") },
        ]);
        const languageOptions = computed(() => [
            { value: "fr-FR", label: t("contact.detail.options.language.french") },
            { value: "en-US", label: t("contact.detail.options.language.english") },
            { value: "nl-NL", label: t("contact.detail.options.language.dutch") },
        ]);
        // ── Profil bloc options (OP-5862) ─────────────────────────────────────────────
        // Contact type is read-only (derived from active org relations). Translated via
        // `contact.detail.profile.typeValue.<member>`; falls back to "—" when the type
        // is absent and to the raw enum value when the translation key is missing
        // (mirrors the category badge fallback — never render a raw i18n key).
        const contactTypeLabel = computed(() => {
            const raw = contact.value?.type;
            if (!raw)
                return "—";
            const key = `contact.detail.profile.typeValue.${raw.toLowerCase()}`;
            const translated = t(key);
            return translated === key ? raw : translated;
        });
        // Multi-categories — OPAL `MultipleSelect` option shape is `{ id, label }`; the
        // v-model is the array of selected `id`s (the raw BFF enum member names).
        const categoryOptions = computed(() => ["Member", "Sympathizer", "Donor", "Volunteer", "Other"].map((value) => ({
            id: value,
            label: t(`contact.detail.profile.options.category.${value.toLowerCase()}`),
            badgeTheme: CATEGORY_THEME_MAP[value],
        })));
        // Single-select profile fields — `value` is the raw BFF enum member name; the
        // empty-string first entry is the "not set" sentinel the form maps to undefined.
        const sourceOptions = computed(() => [
            { value: "", label: t("contact.detail.profile.options.notSet") },
            { value: "Web", label: t("contact.detail.profile.options.source.web") },
            { value: "Phone", label: t("contact.detail.profile.options.source.phone") },
            { value: "InPerson", label: t("contact.detail.profile.options.source.inPerson") },
            { value: "Event", label: t("contact.detail.profile.options.source.event") },
            { value: "Import", label: t("contact.detail.profile.options.source.import") },
            { value: "Other", label: t("contact.detail.profile.options.source.other") },
        ]);
        const motivationOptions = computed(() => [
            { value: "", label: t("contact.detail.profile.options.notSet") },
            { value: "CauseSensitivity", label: t("contact.detail.profile.options.motivation.causeSensitivity") },
            { value: "PersonalExperience", label: t("contact.detail.profile.options.motivation.personalExperience") },
            { value: "Recommendation", label: t("contact.detail.profile.options.motivation.recommendation") },
            { value: "CivicEngagement", label: t("contact.detail.profile.options.motivation.civicEngagement") },
            { value: "TaxBenefit", label: t("contact.detail.profile.options.motivation.taxBenefit") },
        ]);
        const relationLevelOptions = computed(() => [
            { value: "", label: t("contact.detail.profile.options.notSet") },
            { value: "Cold", label: t("contact.detail.profile.options.relationLevel.cold") },
            { value: "Warm", label: t("contact.detail.profile.options.relationLevel.warm") },
            { value: "Engaged", label: t("contact.detail.profile.options.relationLevel.engaged") },
            { value: "Vip", label: t("contact.detail.profile.options.relationLevel.vip") },
            { value: "Institutional", label: t("contact.detail.profile.options.relationLevel.institutional") },
        ]);
        const contactFrequencyOptions = computed(() => [
            { value: "", label: t("contact.detail.profile.options.notSet") },
            { value: "Never", label: t("contact.detail.profile.options.contactFrequency.never") },
            { value: "Occasional", label: t("contact.detail.profile.options.contactFrequency.occasional") },
            { value: "Regular", label: t("contact.detail.profile.options.contactFrequency.regular") },
            { value: "AllCommunications", label: t("contact.detail.profile.options.contactFrequency.allCommunications") },
        ]);
        const preferredChannelOptions = computed(() => [
            { value: "", label: t("contact.detail.profile.options.notSet") },
            { value: "Email", label: t("contact.detail.profile.options.preferredChannel.email") },
            { value: "Mail", label: t("contact.detail.profile.options.preferredChannel.mail") },
            { value: "Phone", label: t("contact.detail.profile.options.preferredChannel.phone") },
            { value: "None", label: t("contact.detail.profile.options.preferredChannel.none") },
        ]);
        // Status options (OP-6070) — Deleted is intentionally excluded (never shown to users).
        const statusOptions = computed(() => [
            { value: "Active", label: t("contact.detail.status.active") },
            { value: "Inactive", label: t("contact.detail.status.inactive") },
            { value: "Suspended", label: t("contact.detail.status.suspended") },
            { value: "Deceased", label: t("contact.detail.status.deceased") },
        ]);
        // ── Coordonnées block (phones / emails) ──────────────────────────────────────
        const { toastSuccess, toastError, toastInfo } = useAppToast();
        const isFormValid = computed(() => identityValid.value && identifiersValid.value);
        // "Ajouter un email" modal (OP-5603 / US-06). The toggle "Définir comme principal"
        // only renders when the contact already owns a primary email — the first email is
        // implicitly primary, so the choice is meaningless until a second is added.
        const showAddEmailModal = ref(false);
        const hasPrimaryEmail = computed(() => (contact.value?.communicationChannels ?? []).some((c) => c.type === "Email" && c.isPrimary && c.value.trim() !== ""));
        // "Modifier l'email" modal (OP-5609 / US-13). Edits an existing email channel (value + primary).
        // The entry point is a pencil icon next to each email row. `editingEmailChannel` snapshots the
        // clicked row so a single modal instance serves every email (primary and non-primary alike).
        const showEditEmailModal = ref(false);
        const editingEmailChannel = ref(null);
        function openEditEmail(channel) {
            editingEmailChannel.value = {
                id: channel.id,
                value: channel.value,
                isPrimary: channel.isPrimary,
                isShared: channel.isShared,
                sharedOwnerRole: channel.sharedOwnerRole,
            };
            showEditEmailModal.value = true;
        }
        // "Modifier le téléphone" modal (OP-5611 / US-15). Edits an existing phone channel
        // (value + subType + primary). The entry point is a pencil icon next to each phone row.
        const showEditPhoneModal = ref(false);
        const editingPhoneChannel = ref(null);
        function toPhoneSubType(raw) {
            return raw === 'Mobile' || raw === 'Fixe' ? raw : undefined;
        }
        function openEditPhone(channel) {
            editingPhoneChannel.value = { id: channel.id, value: channel.value, isPrimary: channel.isPrimary, subType: channel.subType };
            showEditPhoneModal.value = true;
        }
        function openEditChannel(channel) {
            if (channel.type === 'Phone') {
                openEditPhone(channel);
            }
            else {
                openEditEmail(channel);
            }
        }
        // "Ajouter un numéro" modal (OP-5604 / US-07) — same live-save pattern as the
        // email modal. The "Définir comme principal" toggle only renders when the contact
        // already owns a primary phone (the first phone is implicitly primary).
        const showAddPhoneModal = ref(false);
        const hasPrimaryPhone = computed(() => (contact.value?.communicationChannels ?? []).some((c) => c.type === "Phone" && c.isPrimary && c.value.trim() !== ""));
        async function onPhoneCreated() {
            await reload({ silent: true });
            void _reloadContactRelations();
        }
        async function onEmailCreated() {
            await reload({ silent: true });
            void _reloadContactRelations();
        }
        async function onEmailUpdated() {
            await reload({ silent: true });
        }
        // US-14 (OP-5610): deleting an email from the edit modal. The edit modal surfaces the
        // request via `@delete`; we close it and open a destructive confirmation modal scoped to
        // the edited channel. Confirming persists immediately via the BFF (live save) — OPHUB
        // refuses to delete a primary channel (409 `CommunicationChannelCannotBeDeleted`), so the
        // confirm modal warns up-front when the email is primary and the 409 maps to a clear toast.
        const showEmailDeleteConfirm = ref(false);
        // `remaining` = the shared-group members that would survive this deletion (the channel being
        // deleted excluded). Drives the dissolution info toast (US-04d) when exactly one survives.
        const pendingEmailDelete = ref(null);
        // US-04d (OP-5806): designation modal shown ON DELETE when the deleted channel is the shared-group
        // primary and 2+ members would remain — OPHUB needs the successor on the same DELETE.
        const showEmailDeleteDesignate = ref(false);
        const emailDeleteDesignationCandidates = ref([]);
        const emailDeleteDesignating = ref(false);
        const emailDeleteDesignationError = ref(null);
        // OP-5913 (OP-5806 follow-up): single-survivor confirmation on DELETE. When the deleted channel is
        // the shared-group primary and exactly one member remains, OPHUB dissolves the group (no transfer
        // target) and the survivor becomes the primary owner — this dialog acknowledges that before delete.
        const showEmailDeleteLastOwner = ref(false);
        const emailDeleteLastOwnerConfirming = ref(false);
        const emailDeleteLastOwnerError = ref(null);
        const emailDeleteLastOwnerName = computed(() => contactDisplayName(pendingEmailDelete.value?.remaining[0]?.contactName, t));
        async function onEmailDeleteRequested(channel) {
            if (!channel?.id)
                return;
            showEditEmailModal.value = false;
            // For a shared email, resolve the surviving members up-front: a shared-group primary leaving
            // 2+ members triggers the designation modal (US-04d Cas 1); any deletion leaving exactly one
            // member dissolves the group (info toast). Non-shared emails skip straight to the confirm.
            let remaining = [];
            if (channel.isShared) {
                try {
                    const members = await getContactSharedEmailGroup(id.value, channel.id);
                    remaining = members.filter((m) => m.channelId !== channel.id);
                }
                catch (error) {
                    // Detection failed — fall back to the standard confirm (the BE still enforces the rules).
                    logger.error("Failed to load shared email group before delete", error);
                }
            }
            pendingEmailDelete.value = { channelId: channel.id, isPrimary: channel.isPrimary, remaining };
            // A primary email can never be deleted: OPHUB rejects it with 409 CommunicationChannelCannotBeDeleted
            // BEFORE any shared-group transfer (DeleteCommunicationChannelCommandHandler checks IsPrimary first).
            // Routing such a channel into the designation modal would dead-end the user — its error map can't
            // surface that refusal, so the transfer PUT would only ever fail with a generic error and the modal
            // would stay open. Keep it on the standard confirm path (warns up-front, then blocks with a clear
            // message via the pending.isPrimary guard in confirmEmailDelete), exactly like a non-shared primary.
            if (!channel.isPrimary && channel.isShared && channel.sharedOwnerRole === "Principal" && remaining.length >= 2) {
                emailDeleteDesignationCandidates.value = remaining;
                emailDeleteDesignationError.value = null;
                showEmailDeleteDesignate.value = true;
                return;
            }
            // OP-5913 — same guard but exactly one member remains: no designation (single candidate), OPHUB
            // auto-dissolves and the survivor becomes the primary owner. Confirm that before the delete.
            if (!channel.isPrimary && channel.isShared && channel.sharedOwnerRole === "Principal" && remaining.length === 1) {
                emailDeleteLastOwnerError.value = null;
                showEmailDeleteLastOwner.value = true;
                return;
            }
            showEmailDeleteConfirm.value = true;
        }
        // Shared between the standard confirm and the designation confirm: deletes the channel, reloads,
        // and emits the right toast (dissolution info when one member survives, otherwise plain success).
        async function performEmailDelete(channelId, remaining, newPrimaryChannelId) {
            await deleteContactEmail(id.value, channelId, newPrimaryChannelId);
            await reload({ silent: true });
            if (newPrimaryChannelId) {
                toastSuccess("contact.detail.editEmail.deleteConfirm.success");
            }
            else if (remaining.length === 1) {
                const survivor = contactDisplayName(remaining[0].contactName, t);
                toastInfo("contact.detail.editEmail.deleteConfirm.dissolved", { name: survivor });
            }
            else {
                toastSuccess("contact.detail.editEmail.deleteConfirm.success");
            }
        }
        async function confirmEmailDelete() {
            const pending = pendingEmailDelete.value;
            if (!pending)
                return;
            // OPHUB refuses to delete a primary channel (409 CommunicationChannelCannotBeDeleted). The
            // primary flag comes from the freshly-loaded aggregate, so block client-side with a clear,
            // deterministic message instead of firing a delete that can only fail — aligned with the
            // "block + clear message" decision (US-14). The 409 mapping below stays as defense-in-depth
            // for a stale-flag race (e.g. another tab demoted this email between load and confirm).
            if (pending.isPrimary) {
                toastError("contact.detail.editEmail.deleteConfirm.errorPrimary");
                pendingEmailDelete.value = null;
                return;
            }
            try {
                await performEmailDelete(pending.channelId, pending.remaining);
            }
            catch (error) {
                toastError(getApiErrorCode(error) === "CommunicationChannelCannotBeDeleted"
                    ? "contact.detail.editEmail.deleteConfirm.errorPrimary"
                    : "contact.detail.editEmail.deleteConfirm.error");
            }
            finally {
                pendingEmailDelete.value = null;
            }
        }
        // US-04d Cas 1 (≥2 remaining): the user designates the successor; the DELETE carries it so OPHUB
        // transfers ownership and removes the channel in one call. The modal stays open on error.
        async function confirmEmailDeleteDesignation(newPrimaryChannelId) {
            const pending = pendingEmailDelete.value;
            if (!pending)
                return;
            emailDeleteDesignating.value = true;
            emailDeleteDesignationError.value = null;
            try {
                await performEmailDelete(pending.channelId, pending.remaining, newPrimaryChannelId);
                showEmailDeleteDesignate.value = false;
                pendingEmailDelete.value = null;
            }
            catch (error) {
                emailDeleteDesignationError.value = resolveApiErrorMessage(error, EMAIL_DELETE_DESIGNATION_ERROR_OVERRIDES, "contact.detail.designatePrimary.errors.serverError");
                logger.error("Failed to transfer shared email ownership on delete", error);
            }
            finally {
                emailDeleteDesignating.value = false;
            }
        }
        function cancelEmailDeleteDesignation() {
            showEmailDeleteDesignate.value = false;
            emailDeleteDesignationError.value = null;
            pendingEmailDelete.value = null;
        }
        // OP-5913 — single-survivor confirm on DELETE: delete the channel unchanged (no newPrimaryChannelId);
        // OPHUB dissolves the group. performEmailDelete emits the "dissolved" info toast (one survivor).
        // The modal stays open with an inline error on failure, mirroring the designation confirm.
        async function confirmEmailDeleteLastOwner() {
            const pending = pendingEmailDelete.value;
            if (!pending)
                return;
            emailDeleteLastOwnerConfirming.value = true;
            emailDeleteLastOwnerError.value = null;
            try {
                await performEmailDelete(pending.channelId, pending.remaining);
                showEmailDeleteLastOwner.value = false;
                pendingEmailDelete.value = null;
            }
            catch (error) {
                emailDeleteLastOwnerError.value = resolveApiErrorMessage(error, EMAIL_DELETE_DESIGNATION_ERROR_OVERRIDES, "contact.detail.editEmail.deleteConfirm.error");
                logger.error("Failed to dissolve shared email group on delete", error);
            }
            finally {
                emailDeleteLastOwnerConfirming.value = false;
            }
        }
        function cancelEmailDeleteLastOwner() {
            showEmailDeleteLastOwner.value = false;
            emailDeleteLastOwnerError.value = null;
            pendingEmailDelete.value = null;
        }
        // ── Delete contact (OP-7215) ─────────────────────────────────────────────────
        // Path A (no links) / Path B (non-critical links) + Path D (permission) + the shared-email
        // designation wizard (reusing DesignatePrimaryContactModal / ConfirmLastSharedOwnerModal as-is).
        // Path C (critical-link blocking) is out of scope for this ticket — OPHUB's deletion preview
        // never reports one, so the flow below only ever resolves to Path A or B.
        //
        // Verification order mirrors the parent ticket's flow diagram: rights → shared email → path A/B.
        // Rights are checked client-side (canEditOphub) the instant "Supprimer" is clicked, before any
        // preview fetch — there is no separate "delete" capability, ophub.edit covers it. Guarded on
        // isReady first: the profile (and thus canEdit) resolves asynchronously (NavBar fetchProfile),
        // and this route only declares meta.requiresAuth, not requiresCapability, so the router never
        // awaits it — a click before it lands is silently ignored rather than fed to the fail-closed
        // canEdit check, which would otherwise flash the permission-denied modal at a legitimate editor.
        const showDeleteContactPermissionDenied = ref(false);
        const deleteContactChecking = ref(false);
        const deleteContactPreview = ref(null);
        const showDeleteContactConfirm = ref(false);
        const deleteContactSubmitting = ref(false);
        const deleteContactError = ref(null);
        const deleteContactStepSubtitle = ref(null);
        const deleteContactNewPrimaryChannelId = ref(undefined);
        // Step 1 never submits to the server on its own — the chosen channel id is only recorded and
        // sent later, on the same DELETE call as step 2's confirm (confirmDeleteContact). There is no
        // `submitting`/`serverError` state to track here (no API call, no way for it to fail), unlike
        // the email-delete flow's designation step.
        const showDeleteContactDesignate = ref(false);
        const deleteContactDesignationCandidates = ref([]);
        // OP-7428: household mirror of the shared-email designation step above. When the contact is the
        // principal member of a household keeping ≥2 members, the operator must designate the new
        // principal — OPHUB refuses the DELETE otherwise (409 Household.Principal.DesignationRequired);
        // this delete path never auto-promotes. Same record-only mechanics: the chosen contact id rides the final
        // DELETE call. New writes keep a contact in at most ONE active household, but legacy rows can
        // hold more — a preview with >1 household requiring designation is blocked up-front with
        // multipleHouseholdsError (mirroring multipleSharedEmailsError), matching OPHUB's own
        // Household.Principal.MultipleDesignationsRequired 409 preflight.
        const showDeleteContactDesignateHousehold = ref(false);
        const deleteContactNewHouseholdPrincipalContactId = ref(undefined);
        // Derived LIVE from the preview rather than snapshotted into refs at fetch time (same rationale
        // as deleteContactLastOwnerName above): at most ONE household can require a designation, and
        // deriving candidates/name from the preview means nulling the preview on cancel resets
        // everything — no per-ref reset lines to keep in sync, no stale-snapshot hazard.
        const deleteContactDesignationHousehold = computed(() => deleteContactPreview.value?.households.find((h) => h.requiresDesignation) ?? null);
        // Name of the designated new principal, surfaced on the confirm modal's household line in
        // place of the pre-OP-7428 auto-promotion wording.
        const deleteContactNewHouseholdPrincipalName = computed(() => {
            const designatedId = deleteContactNewHouseholdPrincipalContactId.value;
            if (!designatedId)
                return null;
            const candidate = deleteContactDesignationHousehold.value?.candidates.find((m) => m.contactId === designatedId);
            return contactDisplayName(candidate?.contactName, t, "contact.detail.designateHouseholdPrincipal.unknownContact");
        });
        // Derived LIVE from the preview rather than snapshotted into a single ref at fetch time: a contact
        // can own more than one shared-email channel, so the preview can carry SEVERAL groups that dissolve
        // to one survivor at once (two independent groups both auto-dissolving, or one auto-dissolving group
        // alongside a different group that went through the designation wizard). Snapshotting only the
        // FIRST such group left every other survivor's name out of the post-delete "Partage dissous" toast
        // (falling back to "unknown contact") whenever more than one applied. No modal/wizard is tied to
        // this — a primary's single-survivor case goes straight to the step-2 confirm modal, and a
        // secondary's case follows the ordinary Path A/B flow with no special step at all (OP-6527 AC30/AC32).
        const deleteContactLastOwnerName = computed(() => {
            const names = (deleteContactPreview.value?.sharedEmailStatuses ?? [])
                .filter((s) => s.remainingMemberCount === 1)
                .map((s) => s.candidates[0]?.contactName?.trim())
                .filter((name) => !!name);
            return names.length > 0 ? names.join(", ") : t("contact.detail.designatePrimary.unknownContact");
        });
        // A group can dissolve with ZERO remaining members (the deleted contact owned every member of
        // its own shared-email group) — `deleteContactLastOwnerName` has no survivor to name in that
        // case and falls back to the generic "unknown contact" string. Only announce the dissolution
        // toast when a real survivor was resolved; otherwise the plain success toast avoids claiming an
        // unknown contact inherited a channel that in fact no longer exists.
        const deleteContactHasResolvedSurvivor = computed(() => (deleteContactPreview.value?.sharedEmailStatuses ?? []).some((s) => s.remainingMemberCount === 1));
        function openDeleteContactFlow() {
            if (deleteContactChecking.value)
                return;
            if (!isReady.value)
                return;
            if (!canEdit.value) {
                showDeleteContactPermissionDenied.value = true;
                return;
            }
            void startDeleteContactFlow();
        }
        async function startDeleteContactFlow() {
            deleteContactChecking.value = true;
            deleteContactPreview.value = null;
            deleteContactStepSubtitle.value = null;
            deleteContactNewPrimaryChannelId.value = undefined;
            deleteContactNewHouseholdPrincipalContactId.value = undefined;
            deleteContactError.value = null;
            try {
                const preview = await getContactDeletionPreview(id.value);
                deleteContactPreview.value = preview;
                // A contact can be primary of more than one shared-email group at once; today's DELETE
                // contract only carries a SINGLE newPrimaryChannelId, so more than one group requiring a
                // choice always 409s server-side (MultipleTransfersRequired). Block up-front instead of
                // opening a wizard that can only fail.
                const groupsRequiringDesignation = preview.sharedEmailStatuses.filter((s) => s.requiresDesignation);
                if (groupsRequiringDesignation.length > 1) {
                    toastError("contact.detail.deleteContact.multipleSharedEmailsError");
                    return;
                }
                // Same up-front block for legacy multi-household principals (OP-7428): a single
                // newHouseholdPrincipalContactId cannot satisfy two households, and OPHUB rejects the DELETE
                // with Household.Principal.MultipleDesignationsRequired — don't open a wizard that can only fail.
                const householdsRequiringDesignation = preview.households.filter((h) => h.requiresDesignation);
                if (householdsRequiringDesignation.length > 1) {
                    toastError("contact.detail.deleteContact.multipleHouseholdsError");
                    return;
                }
                if (groupsRequiringDesignation.length === 1) {
                    deleteContactDesignationCandidates.value = groupsRequiringDesignation[0].candidates;
                    showDeleteContactDesignate.value = true;
                    return;
                }
                proceedToHouseholdDesignationOrConfirm();
            }
            catch (error) {
                logger.error("Failed to load contact deletion preview", error);
                toastError("contact.detail.deleteContact.previewError");
            }
            finally {
                deleteContactChecking.value = false;
            }
        }
        // After the shared-email designation is resolved (or was never needed): OP-7428 intercalates the
        // household designation step when the contact is the principal of a household keeping ≥2 members,
        // then the flow lands on the Path A/B confirmation.
        function proceedToHouseholdDesignationOrConfirm() {
            if (deleteContactDesignationHousehold.value) {
                showDeleteContactDesignateHousehold.value = true;
                return;
            }
            openDeleteContactConfirmStep();
        }
        // Final step of the wizard: label the confirm modal after whichever designations interceded.
        // The single-survivor shared-email case (auto-dissolve, no designation modal — OP-6527 AC30)
        // also earns the "Email partagé résolu" wording, but only when this contact owns the primary;
        // a secondary member's departure (AC32) stays the ordinary, unlabelled Path A/B flow. `.some()`
        // (not `.find()`) so a primary-dissolving group is never missed just because a
        // secondary-dissolving group happens to sort first in the list.
        function openDeleteContactConfirmStep() {
            const emailResolved = deleteContactNewPrimaryChannelId.value !== undefined ||
                (deleteContactPreview.value?.sharedEmailStatuses.some((s) => s.remainingMemberCount === 1 && s.ownsPrimary) ?? false);
            const householdResolved = deleteContactNewHouseholdPrincipalContactId.value !== undefined;
            if (emailResolved && householdResolved) {
                deleteContactStepSubtitle.value = t("contact.detail.deleteContact.subtitleEmailAndHouseholdResolved");
            }
            else if (householdResolved) {
                deleteContactStepSubtitle.value = t("contact.detail.deleteContact.subtitleHouseholdResolved");
            }
            else if (emailResolved) {
                deleteContactStepSubtitle.value = t("contact.detail.deleteContact.subtitleEmailResolved");
            }
            showDeleteContactConfirm.value = true;
        }
        function cancelDeleteContactDesignation() {
            showDeleteContactDesignate.value = false;
            deleteContactPreview.value = null;
        }
        // Shared-email step → next step: the transfer target is only recorded here — it's sent on the
        // SAME delete call as the final confirm (confirmDeleteContact), exactly like OPHUB expects it.
        function confirmDeleteContactDesignation(newPrimaryChannelId) {
            deleteContactNewPrimaryChannelId.value = newPrimaryChannelId;
            showDeleteContactDesignate.value = false;
            proceedToHouseholdDesignationOrConfirm();
        }
        // Abandoning the household designation abandons the whole deletion (mirror of the shared-email
        // step's cancel) — including any shared-email designation recorded before it.
        function cancelDeleteContactHouseholdDesignation() {
            showDeleteContactDesignateHousehold.value = false;
            deleteContactPreview.value = null;
            deleteContactNewPrimaryChannelId.value = undefined;
        }
        // Household step → confirm: same record-only mechanics as the shared-email designation above.
        function confirmDeleteContactHouseholdDesignation(newPrincipalContactId) {
            deleteContactNewHouseholdPrincipalContactId.value = newPrincipalContactId;
            showDeleteContactDesignateHousehold.value = false;
            openDeleteContactConfirmStep();
        }
        function cancelDeleteContact() {
            showDeleteContactConfirm.value = false;
            deleteContactError.value = null;
            deleteContactPreview.value = null;
            deleteContactNewPrimaryChannelId.value = undefined;
            deleteContactNewHouseholdPrincipalContactId.value = undefined;
            deleteContactStepSubtitle.value = null;
        }
        // Reuses the email-flow's transfer error map: the DELETE call carries the exact same
        // newPrimaryChannelId semantics, so the same server error codes are reachable here — including via
        // a TOCTOU race where a group's membership changes between the preview fetch and this confirm call
        // (e.g. a single-survivor group gains a member, or a second group starts requiring designation).
        const DELETE_CONTACT_ERROR_OVERRIDES = {
            "CommunicationChannel.SharedEmail.InvalidTransferTarget": "contact.detail.designatePrimary.errors.invalidTarget",
            "CommunicationChannel.SharedEmail.TransferRequired": "contact.detail.designatePrimary.errors.serverError",
            "CommunicationChannel.SharedEmail.MultipleTransfersRequired": "contact.detail.deleteContact.multipleSharedEmailsError",
            // OP-7428: same TOCTOU reachability for the household designation — the household's membership
            // can change between the preview fetch and this confirm call (a member removed → the designated
            // target is no longer a member, or a designation becomes required that wasn't at preview time).
            "Household.Principal.InvalidDesignation": "contact.detail.designateHouseholdPrincipal.errors.invalidTarget",
            "Household.Principal.DesignationRequired": "contact.detail.designateHouseholdPrincipal.errors.serverError",
            "Household.Principal.MultipleDesignationsRequired": "contact.detail.deleteContact.multipleHouseholdsError",
        };
        async function confirmDeleteContact() {
            deleteContactSubmitting.value = true;
            deleteContactError.value = null;
            try {
                const result = await deleteContactRequest(id.value, deleteContactNewPrimaryChannelId.value, deleteContactNewHouseholdPrincipalContactId.value);
                showDeleteContactConfirm.value = false;
                if (result.sharedEmailGroupDissolved && deleteContactHasResolvedSurvivor.value) {
                    toastInfo("contact.detail.deleteContact.dissolvedInfo", { name: deleteContactLastOwnerName.value });
                }
                else {
                    toastSuccess("contact.detail.deleteContact.success");
                }
                goBackAfterDeleteContact();
            }
            catch (error) {
                deleteContactError.value = resolveApiErrorMessage(error, DELETE_CONTACT_ERROR_OVERRIDES, "contact.detail.deleteContact.genericError");
                logger.error("Failed to delete contact", error);
            }
            finally {
                deleteContactSubmitting.value = false;
            }
        }
        // No "return to last active view" utility exists in oportal today — router.back() approximates
        // the AC ("dernière vue active") via browser history, falling back to the contact list when the
        // fiche was opened directly (no history entry to go back to).
        function goBackAfterDeleteContact() {
            const historyState = window.history.state;
            if (historyState?.back) {
                router.back();
            }
            else {
                goToList();
            }
        }
        // R70 map for the on-delete transfer. Unlike the edit flow, the DELETE/transfer path picks the
        // successor from the *remaining* members (the leaving channel is excluded), so the backend never
        // emits TransferTargetMustDiffer here — only InvalidTransferTarget is reachable.
        const EMAIL_DELETE_DESIGNATION_ERROR_OVERRIDES = {
            "CommunicationChannel.SharedEmail.InvalidTransferTarget": "contact.detail.designatePrimary.errors.invalidTarget",
        };
        async function onPhoneUpdated() {
            await reload({ silent: true });
        }
        // US-16 (OP-5612): deleting a phone from the edit modal. Mirrors the email delete flow (US-14): the
        // edit modal surfaces the request via `@delete`; we close it and open a destructive confirmation
        // scoped to the edited channel. Confirming persists immediately via the BFF (live save) — OPHUB
        // refuses to delete a primary channel (409 `CommunicationChannelCannotBeDeleted`), so the confirm
        // modal blocks + warns up-front when the phone is primary. Phone specificity: when the number is the
        // contact's only Mobile, an optional warning flags that SMS campaigns can no longer reach them.
        const showPhoneDeleteConfirm = ref(false);
        const pendingPhoneDelete = ref(null);
        // True when the given Mobile channel is the contact's ONLY Mobile number — drives the SMS-campaign
        // warning. A Fixe number never triggers it.
        function isOnlyMobile(channel) {
            if (channel.subType !== "Mobile")
                return false;
            const mobiles = (contact.value?.communicationChannels ?? []).filter((c) => c.type === "Phone" && c.value.trim() !== "" && toPhoneSubType(c.subType) === "Mobile");
            return mobiles.length === 1;
        }
        const phoneDeleteSubtitle = computed(() => {
            const pending = pendingPhoneDelete.value;
            if (!pending)
                return t("contact.detail.editPhone.deleteConfirm.subtitle");
            if (pending.isPrimary)
                return t("contact.detail.editPhone.deleteConfirm.primaryWarning");
            if (pending.isLastMobile)
                return t("contact.detail.editPhone.deleteConfirm.mobileWarning");
            return t("contact.detail.editPhone.deleteConfirm.subtitle");
        });
        function onPhoneDeleteRequested(channel) {
            if (!channel?.id)
                return;
            pendingPhoneDelete.value = {
                channelId: channel.id,
                isPrimary: channel.isPrimary,
                isLastMobile: isOnlyMobile(channel),
            };
            showEditPhoneModal.value = false;
            showPhoneDeleteConfirm.value = true;
        }
        async function confirmPhoneDelete() {
            const pending = pendingPhoneDelete.value;
            if (!pending)
                return;
            // OPHUB refuses to delete a primary channel (409 CommunicationChannelCannotBeDeleted). The primary
            // flag comes from the freshly-loaded aggregate, so block client-side with a clear, deterministic
            // message instead of firing a delete that can only fail — aligned with US-14. The 409 mapping below
            // stays as defense-in-depth for a stale-flag race (e.g. another tab demoted this phone meanwhile).
            if (pending.isPrimary) {
                toastError("contact.detail.editPhone.deleteConfirm.errorPrimary");
                pendingPhoneDelete.value = null;
                return;
            }
            try {
                await deleteContactPhone(id.value, pending.channelId);
                await reload({ silent: true });
                toastSuccess("contact.detail.editPhone.deleteConfirm.success");
            }
            catch (error) {
                toastError(getApiErrorCode(error) === "CommunicationChannelCannotBeDeleted"
                    ? "contact.detail.editPhone.deleteConfirm.errorPrimary"
                    : "contact.detail.editPhone.deleteConfirm.error");
            }
            finally {
                pendingPhoneDelete.value = null;
            }
        }
        // ── Adresses block (OP-5685 / US-08) ─────────────────────────────────────────
        // The Adresses widget lists direct + linked addresses and lets the user pick the
        // single global primary, which persists immediately via the BFF then silently
        // reloads the aggregate. Add (OP-5605) and delete / unlink (PR3) are separate
        // stacked PRs and are not wired here.
        const showExpandAddressesModal = ref(false);
        const openExpandAddresses = () => {
            showExpandAddressesModal.value = true;
        };
        const showAddAddressModal = ref(false);
        const openAddAddress = () => {
            showAddAddressModal.value = true;
        };
        // The add-address modal owns its persistence; on success we silently reload the
        // aggregate so the new row (direct or linked) appears in the block. A pro address
        // auto-creates a contact↔organisation relation, so refresh the relations widget too.
        async function onAddressCreated() {
            await reload({ silent: true });
            void _reloadContactRelations();
            toastSuccess("contact.detail.addresses.addSuccess");
        }
        async function onSetPrimaryAddress(target) {
            try {
                await setContactPrimaryAddress(id.value, target);
                await reload({ silent: true });
                toastSuccess("contact.detail.addresses.setPrimarySuccess");
            }
            catch {
                toastError("contact.detail.addresses.setPrimaryError");
            }
        }
        // US-18.1 (OP-5687): deleting an address. Both the widget row ⋯ menu and the edit-modal
        // footer "Supprimer" button surface the request via @delete. We open a confirmation modal
        // that shows the address, warns when primary, and informs when inherited. Confirming calls
        // the correct BFF endpoint based on source (Direct → delete address, Linked → delete link).
        const showAddressDeleteConfirm = ref(false);
        const pendingAddressDelete = ref(null);
        const addressDeleteModalRef = ref(null);
        function onAddressDeleteRequested(address) {
            pendingAddressDelete.value = address;
            showAddressDeleteConfirm.value = true;
        }
        async function confirmAddressDelete() {
            const address = pendingAddressDelete.value;
            if (!address)
                return;
            addressDeleteModalRef.value?.setDeleting(true);
            addressDeleteModalRef.value?.setError(null);
            try {
                if (address.source === "Linked") {
                    await deleteContactOrgAddressLink(id.value, address.linkId ?? "", address.organisationId ?? "", address.id);
                }
                else {
                    await deleteContactAddress(id.value, address.id);
                }
                showAddressDeleteConfirm.value = false;
                pendingAddressDelete.value = null;
                await reload({ silent: true });
                toastSuccess("contact.detail.addresses.deleteModal.success");
            }
            catch {
                addressDeleteModalRef.value?.setError(t("contact.detail.addresses.deleteModal.error"));
            }
            finally {
                addressDeleteModalRef.value?.setDeleting(false);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(loading))
                    ? (_openBlock(), _createBlock(ContactDetailSkeleton, { key: 0 }))
                    : (_unref(notFound))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(_unref(InlineLink), {
                                    as: _unref(RouterLink),
                                    "icon-left": "ri-arrow-left-line",
                                    to: { name: 'Contact' }
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("common.backToOverview")), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["as"])
                            ]),
                            _createElementVNode("div", _hoisted_3, [
                                _cache[52] || (_cache[52] = _createElementVNode("i", {
                                    class: "ri-user-unfollow-line text-5xl text-gray-300",
                                    "aria-hidden": "true"
                                }, null, -1 /* CACHED */)),
                                _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("contact.detail.notFound.title")), 1 /* TEXT */),
                                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("contact.detail.notFound.description")), 1 /* TEXT */),
                                _createVNode(_unref(Button), {
                                    class: "mt-2",
                                    label: _ctx.$t('common.backToOverview'),
                                    "icon-left": "ri-arrow-left-line",
                                    onClick: goToList
                                }, null, 8 /* PROPS */, ["label"])
                            ])
                        ]))
                        : (_unref(loadError))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_unref(InlineLink), {
                                        as: _unref(RouterLink),
                                        "icon-left": "ri-arrow-left-line",
                                        to: { name: 'Contact' }
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t("common.backToOverview")), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["as"])
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _cache[53] || (_cache[53] = _createElementVNode("i", {
                                        class: "ri-error-warning-line text-5xl text-gray-300",
                                        "aria-hidden": "true"
                                    }, null, -1 /* CACHED */)),
                                    _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t("contact.detail.error.title")), 1 /* TEXT */),
                                    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("contact.detail.error.description")), 1 /* TEXT */),
                                    _createVNode(_unref(Button), {
                                        class: "mt-2",
                                        label: _ctx.$t('common.retry'),
                                        "icon-left": "ri-refresh-line",
                                        onClick: _cache[0] || (_cache[0] = () => _unref(reload)())
                                    }, null, 8 /* PROPS */, ["label"])
                                ])
                            ]))
                            : (_unref(contact))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createVNode(_unref(NavHeader), {
                                        type: "record",
                                        class: "shrink-0",
                                        title: fullName.value,
                                        back: { label: _ctx.$t('common.backToOverview'), href: _unref(router).resolve({ name: 'Contact' }).href },
                                        avatar: {
                                            name: fullName.value,
                                            img: _unref(contact).avatarUrl ?? undefined,
                                            avatarStyle: 'square',
                                            editLabel: _ctx.$t('contact.avatar.editButton'),
                                            editDisabledReason: _ctx.$t('contact.avatar.disabledTooltip'),
                                        },
                                        badges: headerBadges.value,
                                        "secondary-action": { label: _ctx.$t('contact.detail.actions.label'), menu: actionsMenuItems.value },
                                        "icon-actions": pagerActions.value,
                                        onBack: goToList,
                                        onIconAction: handlePagerAction
                                    }, null, 8 /* PROPS */, ["title", "back", "avatar", "badges", "secondary-action", "icon-actions"]),
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, [
                                            _createVNode(_unref(ButtonGroup), {
                                                "aria-label": _ctx.$t('contact.detail.tabs.ariaLabel'),
                                                "model-value": activeTab.value,
                                                "panel-id": _unref(panelId),
                                                "overflow-label": _ctx.$t('common.tabs.next'),
                                                "overflow-previous-label": _ctx.$t('common.tabs.previous'),
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (handleTabChange($event)))
                                            }, {
                                                default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
                                                        return (_openBlock(), _createBlock(_unref(Button), {
                                                            key: tab.key,
                                                            variant: "tertiary",
                                                            size: "sm",
                                                            label: tab.label,
                                                            value: tab.key,
                                                            "data-testid": `contact-detail-tab-${tab.key}`
                                                        }, null, 8 /* PROPS */, ["label", "value", "data-testid"]));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["aria-label", "model-value", "panel-id", "overflow-label", "overflow-previous-label"])
                                        ]),
                                        _createVNode(_unref(FormSaveButton), {
                                            enabled: _unref(canEdit) && _unref(isDirty) && isFormValid.value && !_unref(isSaving),
                                            saving: _unref(isSaving),
                                            "save-label": _ctx.$t('form.saveChanges'),
                                            "saving-label": _ctx.$t('form.saving'),
                                            "disabled-hint": _ctx.$t('form.saveDisabledHint'),
                                            onSave: _unref(saveAll)
                                        }, null, 8 /* PROPS */, ["enabled", "saving", "save-label", "saving-label", "disabled-hint", "onSave"])
                                    ]),
                                    (activeTab.value === 'details')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            id: _unref(panelId),
                                            role: "tabpanel",
                                            "aria-labelledby": _unref(buttonGroupTabId)(_unref(panelId), activeTab.value)
                                        }, [
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("div", _hoisted_16, [
                                                    _createVNode(_unref(WidgetShell), {
                                                        header: _ctx.$t('contact.detail.identity.title')
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_17, [
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(SelectInput), {
                                                                        modelValue: _unref(identity).civility,
                                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(identity).civility) = $event)),
                                                                        label: _ctx.$t('contact.detail.identity.civility'),
                                                                        options: civilityOptions.value,
                                                                        disabled: !_unref(canEdit),
                                                                        "full-width": ""
                                                                    }, null, 8 /* PROPS */, ["modelValue", "label", "options", "disabled"])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(TextInput), {
                                                                        modelValue: _unref(identity).lastName,
                                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(identity).lastName) = $event)),
                                                                        label: _ctx.$t('contact.detail.identity.lastName'),
                                                                        error: _unref(identityErrors).lastName,
                                                                        disabled: !_unref(canEdit),
                                                                        required: "",
                                                                        "full-width": "",
                                                                        "data-testid": "contact-identity-lastname",
                                                                        onBlur: _cache[4] || (_cache[4] = ($event) => (_unref(touchIdentity)('lastName')))
                                                                    }, null, 8 /* PROPS */, ["modelValue", "label", "error", "disabled"])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(TextInput), {
                                                                        modelValue: _unref(identity).firstName,
                                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(identity).firstName) = $event)),
                                                                        label: _ctx.$t('contact.detail.identity.firstName'),
                                                                        error: _unref(identityErrors).firstName,
                                                                        disabled: !_unref(canEdit),
                                                                        required: "",
                                                                        "full-width": "",
                                                                        onBlur: _cache[6] || (_cache[6] = ($event) => (_unref(touchIdentity)('firstName')))
                                                                    }, null, 8 /* PROPS */, ["modelValue", "label", "error", "disabled"])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(TextInput), {
                                                                        modelValue: _unref(identity).courtesy,
                                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(identity).courtesy) = $event)),
                                                                        label: _ctx.$t('contact.detail.identity.courtesy'),
                                                                        error: _unref(identityErrors).courtesy,
                                                                        disabled: !_unref(canEdit),
                                                                        "full-width": "",
                                                                        onBlur: _cache[8] || (_cache[8] = ($event) => (_unref(touchIdentity)('courtesy')))
                                                                    }, null, 8 /* PROPS */, ["modelValue", "label", "error", "disabled"])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(TextInput), {
                                                                        modelValue: _unref(identity).maidenName,
                                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(identity).maidenName) = $event)),
                                                                        label: _ctx.$t('contact.detail.identity.maidenName'),
                                                                        error: _unref(identityErrors).maidenName,
                                                                        disabled: !_unref(canEdit),
                                                                        "full-width": "",
                                                                        onBlur: _cache[10] || (_cache[10] = ($event) => (_unref(touchIdentity)('maidenName')))
                                                                    }, null, 8 /* PROPS */, ["modelValue", "label", "error", "disabled"])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(SelectInput), {
                                                                        modelValue: _unref(identity).gender,
                                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_unref(identity).gender) = $event)),
                                                                        label: _ctx.$t('contact.detail.identity.gender'),
                                                                        options: genderOptions.value,
                                                                        disabled: !_unref(canEdit),
                                                                        "full-width": ""
                                                                    }, null, 8 /* PROPS */, ["modelValue", "label", "options", "disabled"])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(DatePickerInput), {
                                                                        modelValue: identityBirthDateDisplay.value,
                                                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((identityBirthDateDisplay).value = $event)),
                                                                        label: _ctx.$t('contact.detail.identity.birthDate'),
                                                                        format: dateFormat.value,
                                                                        language: _unref(locale),
                                                                        "week-start": 1,
                                                                        error: _unref(identityErrors).birthDate,
                                                                        disabled: !_unref(canEdit),
                                                                        "full-width": "",
                                                                        "data-testid": "contact-identity-birthdate"
                                                                    }, null, 8 /* PROPS */, ["modelValue", "label", "format", "language", "error", "disabled"])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(TextInput), {
                                                                        "model-value": ageLabel.value,
                                                                        label: _ctx.$t('contact.detail.identity.age'),
                                                                        disabled: true,
                                                                        "full-width": "",
                                                                        "data-testid": "contact-identity-age"
                                                                    }, null, 8 /* PROPS */, ["model-value", "label"])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(SelectInput), {
                                                                        modelValue: _unref(identity).preferredLanguage,
                                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(identity).preferredLanguage) = $event)),
                                                                        label: _ctx.$t('contact.detail.identity.preferredLanguage'),
                                                                        options: languageOptions.value,
                                                                        error: _unref(identityErrors).preferredLanguage,
                                                                        disabled: !_unref(canEdit),
                                                                        "full-width": ""
                                                                    }, null, 8 /* PROPS */, ["modelValue", "label", "options", "error", "disabled"])
                                                                ])
                                                            ])
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["header"]),
                                                    _createVNode(_unref(WidgetShell), {
                                                        header: _ctx.$t('contact.detail.profile.title')
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_18, [
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(Tooltip), {
                                                                        class: "w-full",
                                                                        text: _unref(disabledTooltip),
                                                                        disabled: _unref(canEdit),
                                                                        tabindex: _unref(canEdit) ? undefined : 0
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_unref(SelectInput), {
                                                                                modelValue: _unref(profile).status,
                                                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_unref(profile).status) = $event)),
                                                                                label: _ctx.$t('contact.detail.profile.status'),
                                                                                options: statusOptions.value,
                                                                                disabled: !_unref(canEdit),
                                                                                "full-width": "",
                                                                                "data-testid": "contact-profile-status"
                                                                            }, null, 8 /* PROPS */, ["modelValue", "label", "options", "disabled"])
                                                                        ]),
                                                                        _: 1 /* STABLE */
                                                                    }, 8 /* PROPS */, ["text", "disabled", "tabindex"])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(TextInput), {
                                                                        "model-value": contactTypeLabel.value,
                                                                        label: _ctx.$t('contact.detail.profile.type'),
                                                                        disabled: true,
                                                                        "full-width": "",
                                                                        "data-testid": "contact-profile-type"
                                                                    }, null, 8 /* PROPS */, ["model-value", "label"])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(MultipleSelect), {
                                                                        modelValue: _unref(profile).categories,
                                                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_unref(profile).categories) = $event)),
                                                                        options: categoryOptions.value,
                                                                        label: _ctx.$t('contact.detail.profile.categories'),
                                                                        disabled: !_unref(canEdit),
                                                                        placeholder: _ctx.$t('contact.detail.profile.categoriesPlaceholder'),
                                                                        "search-clear-label": _ctx.$t('common.clearSearch'),
                                                                        "search-placeholder": _ctx.$t('contact.detail.profile.categoriesSearch'),
                                                                        "select-all-label": _ctx.$t('contact.detail.profile.categoriesSelectAll'),
                                                                        "clear-all-label": _ctx.$t('contact.detail.profile.categoriesClearAll'),
                                                                        "remove-chip-label": _unref(removeChipLabel),
                                                                        "confirm-label": _ctx.$t('contact.detail.profile.categoriesConfirm'),
                                                                        "empty-label": _ctx.$t('contact.detail.profile.categoriesEmpty'),
                                                                        "full-width": "",
                                                                        "data-testid": "contact-profile-categories"
                                                                    }, null, 8 /* PROPS */, ["modelValue", "options", "label", "disabled", "placeholder", "search-clear-label", "search-placeholder", "select-all-label", "clear-all-label", "remove-chip-label", "confirm-label", "empty-label"])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(SelectInput), {
                                                                        modelValue: _unref(profile).source,
                                                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_unref(profile).source) = $event)),
                                                                        label: _ctx.$t('contact.detail.profile.source'),
                                                                        options: sourceOptions.value,
                                                                        disabled: !_unref(canEdit),
                                                                        "full-width": "",
                                                                        "data-testid": "contact-profile-source"
                                                                    }, null, 8 /* PROPS */, ["modelValue", "label", "options", "disabled"])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(SelectInput), {
                                                                        modelValue: _unref(profile).motivation,
                                                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_unref(profile).motivation) = $event)),
                                                                        label: _ctx.$t('contact.detail.profile.motivation'),
                                                                        options: motivationOptions.value,
                                                                        disabled: !_unref(canEdit),
                                                                        "full-width": ""
                                                                    }, null, 8 /* PROPS */, ["modelValue", "label", "options", "disabled"])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(SelectInput), {
                                                                        modelValue: _unref(profile).relationLevel,
                                                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_unref(profile).relationLevel) = $event)),
                                                                        label: _ctx.$t('contact.detail.profile.relationLevel'),
                                                                        options: relationLevelOptions.value,
                                                                        disabled: !_unref(canEdit),
                                                                        "full-width": ""
                                                                    }, null, 8 /* PROPS */, ["modelValue", "label", "options", "disabled"])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(SelectInput), {
                                                                        modelValue: _unref(profile).contactFrequency,
                                                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_unref(profile).contactFrequency) = $event)),
                                                                        label: _ctx.$t('contact.detail.profile.contactFrequency'),
                                                                        options: contactFrequencyOptions.value,
                                                                        disabled: !_unref(canEdit),
                                                                        "full-width": ""
                                                                    }, null, 8 /* PROPS */, ["modelValue", "label", "options", "disabled"])
                                                                ]),
                                                                _createElementVNode("div", null, [
                                                                    _createVNode(_unref(SelectInput), {
                                                                        modelValue: _unref(profile).preferredChannel,
                                                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_unref(profile).preferredChannel) = $event)),
                                                                        label: _ctx.$t('contact.detail.profile.preferredChannel'),
                                                                        options: preferredChannelOptions.value,
                                                                        disabled: !_unref(canEdit),
                                                                        "full-width": ""
                                                                    }, null, 8 /* PROPS */, ["modelValue", "label", "options", "disabled"])
                                                                ])
                                                            ])
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["header"]),
                                                    false
                                                        ? (_openBlock(), _createBlock(_unref(WidgetShell), {
                                                            key: 0,
                                                            header: _ctx.$t('contact.detail.identifiers.title')
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("div", _hoisted_19, [
                                                                    _createElementVNode("div", null, [
                                                                        _createVNode(_unref(TextInput), {
                                                                            modelValue: _unref(identifiers).eudonetId,
                                                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_unref(identifiers).eudonetId) = $event)),
                                                                            label: _ctx.$t('contact.detail.identifiers.eudonetId'),
                                                                            error: _unref(identifiersErrors).eudonetId,
                                                                            disabled: !_unref(canEdit),
                                                                            "full-width": ""
                                                                        }, null, 8 /* PROPS */, ["modelValue", "label", "error", "disabled"])
                                                                    ]),
                                                                    _createElementVNode("div", null, [
                                                                        _createVNode(_unref(TextInput), {
                                                                            modelValue: _unref(identifiers).ineNumber,
                                                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_unref(identifiers).ineNumber) = $event)),
                                                                            label: _ctx.$t('contact.detail.identifiers.ineNumber'),
                                                                            error: _unref(identifiersErrors).ineNumber,
                                                                            disabled: !_unref(canEdit),
                                                                            "full-width": ""
                                                                        }, null, 8 /* PROPS */, ["modelValue", "label", "error", "disabled"])
                                                                    ]),
                                                                    _createElementVNode("div", null, [
                                                                        _createVNode(_unref(TextInput), {
                                                                            modelValue: _unref(identifiers).lmsId,
                                                                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_unref(identifiers).lmsId) = $event)),
                                                                            label: _ctx.$t('contact.detail.identifiers.lmsId'),
                                                                            error: _unref(identifiersErrors).lmsId,
                                                                            disabled: !_unref(canEdit),
                                                                            "full-width": ""
                                                                        }, null, 8 /* PROPS */, ["modelValue", "label", "error", "disabled"])
                                                                    ]),
                                                                    _createElementVNode("div", null, [
                                                                        _createVNode(_unref(TextInput), {
                                                                            modelValue: _unref(identifiers).parcoursupId,
                                                                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_unref(identifiers).parcoursupId) = $event)),
                                                                            label: _ctx.$t('contact.detail.identifiers.parcoursupId'),
                                                                            error: _unref(identifiersErrors).parcoursupId,
                                                                            disabled: !_unref(canEdit),
                                                                            "full-width": ""
                                                                        }, null, 8 /* PROPS */, ["modelValue", "label", "error", "disabled"])
                                                                    ]),
                                                                    _createElementVNode("div", null, [
                                                                        _createVNode(_unref(TextInput), {
                                                                            modelValue: _unref(identifiers).campusFranceNumber,
                                                                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((_unref(identifiers).campusFranceNumber) = $event)),
                                                                            label: _ctx.$t('contact.detail.identifiers.campusFranceNumber'),
                                                                            error: _unref(identifiersErrors).campusFranceNumber,
                                                                            disabled: !_unref(canEdit),
                                                                            "full-width": ""
                                                                        }, null, 8 /* PROPS */, ["modelValue", "label", "error", "disabled"])
                                                                    ])
                                                                ])
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["header"]))
                                                        : _createCommentVNode("v-if", true),
                                                    _createVNode(ContactActiveRelationsWidget, {
                                                        "contact-id": id.value,
                                                        relations: _unref(_contactOrgRelations),
                                                        "relations-loading": _unref(_contactRelationsLoading),
                                                        "relations-load-error": _unref(_contactRelationsLoadError),
                                                        onNavigateToRelations: navigateToRelations,
                                                        onReloadRelations: _unref(_reloadContactRelations)
                                                    }, null, 8 /* PROPS */, ["contact-id", "relations", "relations-loading", "relations-load-error", "onReloadRelations"])
                                                ]),
                                                _createElementVNode("div", _hoisted_20, [
                                                    _createVNode(_unref(WidgetShell), {
                                                        header: _ctx.$t('contact.detail.contactInformation.title')
                                                    }, {
                                                        actions: _withCtx(() => [
                                                            _createVNode(_unref(Tooltip), {
                                                                text: _unref(disabledTooltip),
                                                                disabled: _unref(canEdit)
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_unref(Dropdown), {
                                                                        items: coordonneesAddItems.value,
                                                                        "menu-align": "right"
                                                                    }, {
                                                                        trigger: _withCtx(({ triggerProps }) => [
                                                                            _createVNode(_unref(Button), _mergeProps(triggerProps, {
                                                                                variant: "primary",
                                                                                size: "sm",
                                                                                "icon-left": "ri-add-line",
                                                                                "dropdown-icon": "",
                                                                                label: _ctx.$t('common.addNew'),
                                                                                disabled: !_unref(canEdit),
                                                                                "data-testid": "contact-add-channel"
                                                                            }), null, 16 /* FULL_PROPS */, ["label", "disabled"])
                                                                        ]),
                                                                        _: 1 /* STABLE */
                                                                    }, 8 /* PROPS */, ["items"])
                                                                ]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["text", "disabled"])
                                                        ]),
                                                        default: _withCtx(() => [
                                                            _createVNode(ContactCoordonneesSection, {
                                                                channels: _unref(contact).communicationChannels,
                                                                "can-edit": _unref(canEdit),
                                                                onEditChannel: openEditChannel
                                                            }, null, 8 /* PROPS */, ["channels", "can-edit"]),
                                                            _createVNode(ContactSocialProfileSection, {
                                                                profiles: socialProfiles.value,
                                                                "can-edit": _unref(canEdit),
                                                                class: "mt-4",
                                                                onEdit: openEditSocialProfile
                                                            }, null, 8 /* PROPS */, ["profiles", "can-edit"])
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["header"]),
                                                    _createVNode(ContactAddressesWidget, {
                                                        addresses: _unref(contact).addresses,
                                                        "contact-id": id.value,
                                                        "can-edit": _unref(canEdit),
                                                        onAdd: openAddAddress,
                                                        onExpand: openExpandAddresses,
                                                        "onUpdate:primary": onSetPrimaryAddress,
                                                        onDelete: onAddressDeleteRequested,
                                                        onUpdated: _cache[26] || (_cache[26] = ($event) => (_unref(reload)({ silent: true })))
                                                    }, null, 8 /* PROPS */, ["addresses", "contact-id", "can-edit"]),
                                                    (_unref(canAdminOpink))
                                                        ? (_openBlock(), _createBlock(ContactConsentsWidget, {
                                                            key: 0,
                                                            "contact-id": id.value,
                                                            channels: _unref(contact).communicationChannels,
                                                            onViewAll: _cache[27] || (_cache[27] = ($event) => (handleTabChange('consents')))
                                                        }, null, 8 /* PROPS */, ["contact-id", "channels"]))
                                                        : _createCommentVNode("v-if", true)
                                                ])
                                            ])
                                        ], 8 /* PROPS */, _hoisted_14))
                                        : _createCommentVNode("v-if", true),
                                    (activeTab.value === 'relations')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            id: _unref(panelId),
                                            role: "tabpanel",
                                            "aria-labelledby": _unref(buttonGroupTabId)(_unref(panelId), activeTab.value),
                                            class: "flex-1 flex flex-col"
                                        }, [
                                            _createVNode(ContactRelationsTab, {
                                                ref_key: "relationsTabRef",
                                                ref: relationsTabRef,
                                                "contact-id": id.value,
                                                "initial-sub-tab": relationsInitialSubTab.value,
                                                onRelationsChanged: _cache[28] || (_cache[28] = () => { _unref(reload)({ silent: true }); void _unref(_reloadContactRelations)(); })
                                            }, null, 8 /* PROPS */, ["contact-id", "initial-sub-tab"])
                                        ], 8 /* PROPS */, _hoisted_21))
                                        : _createCommentVNode("v-if", true),
                                    (activeTab.value === 'donations')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 2,
                                            id: _unref(panelId),
                                            role: "tabpanel",
                                            "aria-labelledby": _unref(buttonGroupTabId)(_unref(panelId), activeTab.value),
                                            class: "flex-1 flex flex-col [&>*]:flex-1"
                                        }, [
                                            _createVNode(ContactDonationsTab, {
                                                "contact-id": id.value,
                                                "contact-name": fullName.value
                                            }, null, 8 /* PROPS */, ["contact-id", "contact-name"])
                                        ], 8 /* PROPS */, _hoisted_22))
                                        : _createCommentVNode("v-if", true),
                                    (activeTab.value === 'subscriptions')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 3,
                                            id: _unref(panelId),
                                            role: "tabpanel",
                                            "aria-labelledby": _unref(buttonGroupTabId)(_unref(panelId), activeTab.value),
                                            class: "flex-1 flex flex-col [&>*]:flex-1"
                                        }, [
                                            _createVNode(ContactSubscriptionsTab, {
                                                "contact-id": id.value,
                                                "contact-name": fullName.value
                                            }, null, 8 /* PROPS */, ["contact-id", "contact-name"])
                                        ], 8 /* PROPS */, _hoisted_23))
                                        : _createCommentVNode("v-if", true),
                                    (activeTab.value === 'consents')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 4,
                                            id: _unref(panelId),
                                            role: "tabpanel",
                                            "aria-labelledby": _unref(buttonGroupTabId)(_unref(panelId), activeTab.value),
                                            class: "flex-1 flex flex-col [&>*]:flex-1"
                                        }, [
                                            _createVNode(ContactConsentsTab, {
                                                "contact-id": id.value,
                                                channels: _unref(contact).communicationChannels
                                            }, null, 8 /* PROPS */, ["contact-id", "channels"])
                                        ], 8 /* PROPS */, _hoisted_24))
                                        : _createCommentVNode("v-if", true)
                                ]))
                                : _createCommentVNode("v-if", true),
                _createVNode(_unref(UnsavedChangesModal), {
                    modelValue: showUnsavedChangesModal.value,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((showUnsavedChangesModal).value = $event)),
                    title: _ctx.$t('leaveWithoutSaving.title'),
                    message: _ctx.$t('leaveWithoutSaving.message'),
                    "stay-label": _ctx.$t('leaveWithoutSaving.stay'),
                    "leave-label": _ctx.$t('leaveWithoutSaving.leave'),
                    "save-label": _ctx.$t('leaveWithoutSaving.save'),
                    "save-disabled": _unref(isSaving) || !isFormValid.value,
                    onDiscard: handleLeave,
                    onSave: handleSaveAndContinue,
                    onStay: handleStay
                }, null, 8 /* PROPS */, ["modelValue", "title", "message", "stay-label", "leave-label", "save-label", "save-disabled"]),
                _createVNode(ContactAddEmailModal, {
                    modelValue: showAddEmailModal.value,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => ((showAddEmailModal).value = $event)),
                    "contact-id": id.value,
                    "contact-name": fullName.value,
                    "has-primary-email": hasPrimaryEmail.value,
                    "existing-relation-org-ids": existingRelationOrgIds.value,
                    onCreated: onEmailCreated
                }, null, 8 /* PROPS */, ["modelValue", "contact-id", "contact-name", "has-primary-email", "existing-relation-org-ids"]),
                (editingEmailChannel.value)
                    ? (_openBlock(), _createBlock(ContactEditEmailModal, {
                        key: 4,
                        modelValue: showEditEmailModal.value,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => ((showEditEmailModal).value = $event)),
                        "contact-id": id.value,
                        "channel-id": editingEmailChannel.value.id,
                        "initial-value": editingEmailChannel.value.value,
                        "initial-is-primary": editingEmailChannel.value.isPrimary,
                        "is-shared": editingEmailChannel.value.isShared,
                        "shared-owner-role": editingEmailChannel.value.sharedOwnerRole,
                        onUpdated: onEmailUpdated,
                        onDelete: _cache[32] || (_cache[32] = ($event) => (onEmailDeleteRequested(editingEmailChannel.value)))
                    }, null, 8 /* PROPS */, ["modelValue", "contact-id", "channel-id", "initial-value", "initial-is-primary", "is-shared", "shared-owner-role"]))
                    : _createCommentVNode("v-if", true),
                _createVNode(_unref(ConfirmDeleteModal), {
                    modelValue: showEmailDeleteConfirm.value,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => ((showEmailDeleteConfirm).value = $event)),
                    title: _ctx.$t('contact.detail.editEmail.deleteConfirm.title'),
                    subtitle: pendingEmailDelete.value?.isPrimary
                        ? _ctx.$t('contact.detail.editEmail.deleteConfirm.primaryWarning')
                        : _ctx.$t('contact.detail.editEmail.deleteConfirm.subtitle'),
                    "confirm-label": _ctx.$t('contact.detail.editEmail.deleteConfirm.confirmLabel'),
                    "cancel-label": _ctx.$t('form.cancel'),
                    "confirm-disabled": pendingEmailDelete.value?.isPrimary === true,
                    onConfirm: confirmEmailDelete
                }, null, 8 /* PROPS */, ["modelValue", "title", "subtitle", "confirm-label", "cancel-label", "confirm-disabled"]),
                _createVNode(DesignatePrimaryContactModal, {
                    modelValue: showEmailDeleteDesignate.value,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event) => ((showEmailDeleteDesignate).value = $event)),
                    members: emailDeleteDesignationCandidates.value,
                    submitting: emailDeleteDesignating.value,
                    "server-error": emailDeleteDesignationError.value,
                    "back-label-key": "cancel",
                    onBack: cancelEmailDeleteDesignation,
                    onConfirm: confirmEmailDeleteDesignation
                }, null, 8 /* PROPS */, ["modelValue", "members", "submitting", "server-error"]),
                _createVNode(ConfirmLastSharedOwnerModal, {
                    modelValue: showEmailDeleteLastOwner.value,
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event) => ((showEmailDeleteLastOwner).value = $event)),
                    mode: "delete",
                    name: emailDeleteLastOwnerName.value,
                    submitting: emailDeleteLastOwnerConfirming.value,
                    "server-error": emailDeleteLastOwnerError.value,
                    onConfirm: confirmEmailDeleteLastOwner,
                    onCancel: cancelEmailDeleteLastOwner
                }, null, 8 /* PROPS */, ["modelValue", "name", "submitting", "server-error"]),
                (editingPhoneChannel.value)
                    ? (_openBlock(), _createBlock(ContactEditPhoneModal, {
                        key: 5,
                        modelValue: showEditPhoneModal.value,
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event) => ((showEditPhoneModal).value = $event)),
                        "contact-id": id.value,
                        "channel-id": editingPhoneChannel.value.id,
                        "initial-value": editingPhoneChannel.value.value,
                        "initial-is-primary": editingPhoneChannel.value.isPrimary,
                        "initial-sub-type": toPhoneSubType(editingPhoneChannel.value.subType),
                        onUpdated: onPhoneUpdated,
                        onDelete: _cache[37] || (_cache[37] = ($event) => (onPhoneDeleteRequested(editingPhoneChannel.value)))
                    }, null, 8 /* PROPS */, ["modelValue", "contact-id", "channel-id", "initial-value", "initial-is-primary", "initial-sub-type"]))
                    : _createCommentVNode("v-if", true),
                _createVNode(_unref(ConfirmDeleteModal), {
                    modelValue: showPhoneDeleteConfirm.value,
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event) => ((showPhoneDeleteConfirm).value = $event)),
                    title: _ctx.$t('contact.detail.editPhone.deleteConfirm.title'),
                    subtitle: phoneDeleteSubtitle.value,
                    "confirm-label": _ctx.$t('contact.detail.editPhone.deleteConfirm.confirmLabel'),
                    "cancel-label": _ctx.$t('form.cancel'),
                    "confirm-disabled": pendingPhoneDelete.value?.isPrimary === true,
                    onConfirm: confirmPhoneDelete
                }, null, 8 /* PROPS */, ["modelValue", "title", "subtitle", "confirm-label", "cancel-label", "confirm-disabled"]),
                (_unref(contact))
                    ? (_openBlock(), _createBlock(ContactAddressesExpandModal, {
                        key: 6,
                        modelValue: showExpandAddressesModal.value,
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event) => ((showExpandAddressesModal).value = $event)),
                        addresses: _unref(contact).addresses,
                        "contact-id": id.value,
                        "can-edit": _unref(canEdit),
                        "onUpdate:primary": onSetPrimaryAddress,
                        onDelete: onAddressDeleteRequested,
                        onUpdated: _cache[40] || (_cache[40] = ($event) => (_unref(reload)({ silent: true })))
                    }, null, 8 /* PROPS */, ["modelValue", "addresses", "contact-id", "can-edit"]))
                    : _createCommentVNode("v-if", true),
                (pendingAddressDelete.value)
                    ? (_openBlock(), _createBlock(ContactDeleteAddressModal, {
                        key: 7,
                        ref_key: "addressDeleteModalRef",
                        ref: addressDeleteModalRef,
                        modelValue: showAddressDeleteConfirm.value,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event) => ((showAddressDeleteConfirm).value = $event)),
                        address: pendingAddressDelete.value,
                        onConfirm: confirmAddressDelete
                    }, null, 8 /* PROPS */, ["modelValue", "address"]))
                    : _createCommentVNode("v-if", true),
                (_unref(contact))
                    ? (_openBlock(), _createBlock(ContactAddressFormModal, {
                        key: 8,
                        modelValue: showAddAddressModal.value,
                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event) => ((showAddAddressModal).value = $event)),
                        "contact-id": id.value,
                        "existing-addresses": _unref(contact).addresses,
                        onCreated: onAddressCreated
                    }, null, 8 /* PROPS */, ["modelValue", "contact-id", "existing-addresses"]))
                    : _createCommentVNode("v-if", true),
                _createVNode(_unref(SocialProfileFormModal), {
                    modelValue: showSocialModal.value,
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event) => ((showSocialModal).value = $event)),
                    profile: editingSocialProfile.value,
                    "existing-network-ids": socialProfiles.value.map((p) => p.networkId),
                    error: socialModalError.value,
                    loading: socialModalLoading.value,
                    "platform-picker-enabled": "",
                    "delete-enabled": "",
                    onSave: onSocialProfileSave,
                    onDelete: onSocialProfileDelete
                }, null, 8 /* PROPS */, ["modelValue", "profile", "existing-network-ids", "error", "loading"]),
                _createVNode(ContactAddPhoneModal, {
                    modelValue: showAddPhoneModal.value,
                    "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event) => ((showAddPhoneModal).value = $event)),
                    "contact-id": id.value,
                    "contact-name": fullName.value,
                    "has-primary-phone": hasPrimaryPhone.value,
                    "existing-relation-org-ids": existingRelationOrgIds.value,
                    onCreated: onPhoneCreated
                }, null, 8 /* PROPS */, ["modelValue", "contact-id", "contact-name", "has-primary-phone", "existing-relation-org-ids"]),
                _createVNode(ContactPropertiesModal, {
                    modelValue: showPropertiesModal.value,
                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event) => ((showPropertiesModal).value = $event)),
                    properties: contactProperties.value,
                    "legal-name": fullName.value
                }, null, 8 /* PROPS */, ["modelValue", "properties", "legal-name"]),
                _createVNode(ContactDeletePermissionDeniedModal, {
                    modelValue: showDeleteContactPermissionDenied.value,
                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event) => ((showDeleteContactPermissionDenied).value = $event))
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createVNode(DesignateHouseholdPrincipalModal, {
                    modelValue: showDeleteContactDesignateHousehold.value,
                    "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event) => ((showDeleteContactDesignateHousehold).value = $event)),
                    members: deleteContactDesignationHousehold.value?.candidates ?? [],
                    "household-name": deleteContactDesignationHousehold.value?.name ?? '',
                    onBack: cancelDeleteContactHouseholdDesignation,
                    onConfirm: confirmDeleteContactHouseholdDesignation
                }, null, 8 /* PROPS */, ["modelValue", "members", "household-name"]),
                _createVNode(DesignatePrimaryContactModal, {
                    modelValue: showDeleteContactDesignate.value,
                    "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event) => ((showDeleteContactDesignate).value = $event)),
                    members: deleteContactDesignationCandidates.value,
                    "back-label-key": "cancel",
                    onBack: cancelDeleteContactDesignation,
                    onConfirm: confirmDeleteContactDesignation
                }, null, 8 /* PROPS */, ["modelValue", "members"]),
                _createVNode(DeleteContactModal, {
                    modelValue: showDeleteContactConfirm.value,
                    "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event) => ((showDeleteContactConfirm).value = $event)),
                    preview: deleteContactPreview.value,
                    "household-new-principal-name": deleteContactNewHouseholdPrincipalName.value,
                    "contact-name": fullName.value,
                    "step-subtitle": deleteContactStepSubtitle.value,
                    submitting: deleteContactSubmitting.value,
                    "server-error": deleteContactError.value,
                    onConfirm: confirmDeleteContact,
                    onCancel: cancelDeleteContact
                }, null, 8 /* PROPS */, ["modelValue", "preview", "household-new-principal-name", "contact-name", "step-subtitle", "submitting", "server-error"]),
                (canPseudonymise.value)
                    ? (_openBlock(), _createBlock(_unref(PseudonymiseContactModal), {
                        key: 9,
                        modelValue: showPseudonymiseModal.value,
                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event) => ((showPseudonymiseModal).value = $event)),
                        "contact-id": id.value,
                        "contact-name": fullName.value,
                        onCompleted: _cache[51] || (_cache[51] = ($event) => (_unref(reload)({ silent: true })))
                    }, null, 8 /* PROPS */, ["modelValue", "contact-id", "contact-name"]))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
